<script>
    import Header from './Header.svelte'
    import { onDestroy, onMount } from 'svelte'
    import { currentUserStore } from './stores'
    import { db } from './firebase'
    import { push } from 'svelte-spa-router'

    let currentUser
    const unsubscribe = currentUserStore.subscribe(value => {
        currentUser = value
    })

    let forms = []
    let loading = true
    let showClosedForms = false

    onMount(() => {
		getForms()
	})
    onDestroy(() => {
        unsubscribe()
    })

    const getForms = () => {
        // db.collection('forms').where('permittedEditors', 'array-contains', currentUser.uid).get().then(querySnapshot => {
        //     querySnapshot.forEach(doc => {
        //         let formWithID = doc.data()
        //         formWithID.id = doc.id
        //         forms = [...forms, formWithID]
        //     })
        //     console.log(forms)
        //     loading = false
        // })
        // .orderBy('formOpen', 'desc').orderBy('title')
		db.collection('forms').where('permittedVoters', 'array-contains', true).get().then(querySnapshot => {
            querySnapshot.forEach(doc => {
                let formWithID = doc.data()
                formWithID.id = doc.id
                forms = [...forms, formWithID]
            })
            console.log(forms)
            loading = false
        })
	}
    const createNewForm = () => {
        let formId = prompt('Enter a form id')
        db.collection('forms').doc(formId).set({
            title: 'Untitled Form',
            questions: [
                {
                    question: 'First question',
                    type: 'short-text'
                }
            ],
            permittedEditors: [currentUser.uid],
            permittedVoters: [true],
            formOpen: true
        })
    }
</script>

<Header title='Homepage'/>
{#if !loading}
<div class="content">
    {#each forms as form}
        {#if form.formOpen == true || form.formOpen == false && showClosedForms == true}
        <div class="card">
            <!-- <div class="info"> -->
                <div class="status-indicator" class:open={form.formOpen}/>
                <p class="title" on:click={() => push('/' + form.id)}>{form.title}</p>
                <p class="label">{form.questions.length} questions</p>
                {#if form.permittedEditors.includes(currentUser.uid)}
                    <div class="menu-icon" on:click={() => push('/' + form.id + '/edit')}></div>
                {/if}
            <!-- </div> -->
        </div>
        {/if}
    {/each}
    <button on:click={() => showClosedForms = !showClosedForms}>{showClosedForms ? 'Hide Closed Forms' : 'Show Closed Forms'}</button>
    <button on:click={createNewForm}>Create new form</button>
</div>
{/if}

<style>
    .content {
        align-self: start;
    }
    /* .card {
        display: inline-grid;
        grid-template: 108px 60px / 360px;
        width: min-content;
        border: 1px solid var(--background-tertiary);
        border-radius: 6px;
        margin: 0 12px 12px 0;
    }
    .card .info {
        margin: 30px 30px;
    }
    .card .info p {
        margin: 0;
    }
    .card .buttons {
        background: var(--background-secondary);
        margin: 0;
        height: 100%;
        border-radius: 0 0 5px 5px;
    }
    .card .buttons .button {
        line-height: 20px;
        margin: 20px 0;
        padding: 0 24px;
        float: left;
        cursor: pointer;
        font-size: 0.9em;
    }
    .card .buttons .button:not(:first-child) {
        border-left: 1px solid var(--content-secondary);
    } */
    .card {
        display: inline-grid;
        grid-template: 62px 1fr 34px / 36px 184px;
        background: #1F1F1F;
        border-radius: 6px;
        margin: 0 8px 8px 0;
    }
    .card .status-indicator {
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #666666;
        align-self: center;
        justify-self: end;
        margin-right: 9px;
    }
    .card .status-indicator.open {
        background: #A5DE24;
    }
    .card .title {
        grid-row: 1;
        grid-column: 2;
        margin: 0;
        align-self: end;
        margin-bottom: 18px;
        cursor: pointer;
    }
    .card .label {
        grid-row: 1;
        grid-column: 2;
        align-self: end;
        margin: 0;
        font-size: 14px;
        font-weight: 400;
    }
    .card .menu-icon {
        grid-row: 1;
        grid-column: 2;
        justify-self: end;
        align-self: center;
        margin-right: 16px;
        background: url('/assets/menu.svg');
        width: 18px;
        height: 18px;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }
</style>